import { createContext, useContext, useState, useCallback } from 'react';

// Create context
const RefetchContext = createContext();

// Provider
export const RefetchProvider = ({ children }) => {
  const [refetchKey, setRefetchKey] = useState(0);

  // This function will "trigger" refetch by changing the key
  const triggerRefetch = useCallback(() => {
    setRefetchKey(prev => prev + 1);
  }, []);

  return (
    <RefetchContext.Provider value={{ refetchKey, triggerRefetch }}>
      {children}
    </RefetchContext.Provider>
  );
};

// Hook to use in components
export const useRefetchTrigger = () => {
  const context = useContext(RefetchContext);
  if (!context) {
    throw new Error('useRefetchTrigger must be used inside a <RefetchProvider>');
  }
  return context;
};